import { Injectable } from '@angular/core';
import { ApiNameList } from '../../../environments/api-name-list';
import { HttpClientService } from './http-client-service';

@Injectable()
export class HomeService {
    public baseUrl = '';
    constructor(public httpClientService: HttpClientService) {
        this.baseUrl = ApiNameList.restApi.baseUrl;
    }

    getLandingData(participationId: number) {
        const requestObject = {
            participationId: participationId
        };
        return this.httpClientService.post(this.baseUrl + ApiNameList.restApi.landing, requestObject);
    }

    getEnrollmentStatus(participationId: number) {
        const requestObject = {
            participationId: participationId
        };
        return this.httpClientService.post(this.baseUrl + ApiNameList.restApi.enrollmentStatus, requestObject);
    }

    getPlanStatus(request: any) {
        return this.httpClientService.post(this.baseUrl + ApiNameList.restApi.planStatus, request);
    }

    getValidateToken(request: {userId: string, jwtToken: string}) {
        return this.httpClientService.post(this.baseUrl + ApiNameList.restApi.validateToken, request);
    }

    getStoryLandingInfo(storyId: string) {
        const requestObject = {
            storyId: storyId
        };
        return this.httpClientService.post(this.baseUrl + ApiNameList.restApi.campusLanding, requestObject);
    }
    
    manageMicrositeDashboard(request: any) {
        return this.httpClientService.post(this.baseUrl + ApiNameList.restApi.manageMicrositeDashboard, request);      
    }
}